import { BoxProps, SkeletonCircle, SkeletonText } from '@chakra-ui/react';
import * as React from 'react';

import { Card } from '@/imports/ui/chakra/components/Card';

export const Post: React.FC<BoxProps> = ({ ...boxProps }) => {
  return (
    <Card p="4" {...boxProps}>
      <SkeletonCircle size="10" />
      <SkeletonText mt="4" noOfLines={5} spacing="4" />
    </Card>
  );
};
